import type { StorageAllocation } from '@garage/shared'

export const ALLOCATION_SORT_KEYS = [
  'name-asc',
  'name-desc',
  'quantity-desc',
  'quantity-asc',
  'added-desc',
  'added-asc',
] as const
export type AllocationSortKey = (typeof ALLOCATION_SORT_KEYS)[number]

const byName = (a: StorageAllocation, b: StorageAllocation) =>
  a.itemName.localeCompare(b.itemName, undefined, { numeric: true, sensitivity: 'base' })

/** A new array; the query cache's own list is never reordered in place. */
export function sortAllocations(list: readonly StorageAllocation[], key: AllocationSortKey): StorageAllocation[] {
  const out = [...list]
  switch (key) {
    case 'name-asc':
      return out.sort(byName)
    case 'name-desc':
      return out.sort((a, b) => byName(b, a))
    case 'quantity-desc':
      return out.sort((a, b) => b.quantity - a.quantity || byName(a, b))
    case 'quantity-asc':
      return out.sort((a, b) => a.quantity - b.quantity || byName(a, b))
    case 'added-desc':
      return out.sort((a, b) => b.createdAt.localeCompare(a.createdAt) || byName(a, b))
    case 'added-asc':
      return out.sort((a, b) => a.createdAt.localeCompare(b.createdAt) || byName(a, b))
  }
}
